import { layoutModeTokens, useLayoutMode } from '@/ui/layouts/layoutMode';
import { Box, Text } from '@/ui/primitives';
import { s } from '../../theme/tokens';
import type { ReactElement, ReactNode } from 'react';

type PageHeaderProps = { title: ReactNode; subtitle?: ReactNode; actions?: ReactNode };

export const PageHeader = ({ title, subtitle, actions }: PageHeaderProps): ReactElement => {
  const layoutMode = useLayoutMode();
  const isCompact = layoutMode === layoutModeTokens.compact;

  const titleNode =
    typeof title === 'string' || typeof title === 'number' ? (
      <Text role="sectionTitle" component="h1">
        {title}
      </Text>
    ) : (
      title
    );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isCompact ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: isCompact ? 'flex-start' : 'center',
        gap: s('md'),
      }}
    >
      <Box
        sx={{
          minWidth: 0,
          flex: '1 1 auto',
          '&, & *': {
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          },
        }}
      >
        {titleNode}
        {subtitle ? (
          <Text role="bodyMuted" sx={{ marginTop: s('xs') }}>
            {subtitle}
          </Text>
        ) : null}
      </Box>
      {actions ? <Box sx={{ flexShrink: 0 }}>{actions}</Box> : null}
    </Box>
  );
};
